// frontend/src/components/common/RiskChip.jsx
// Risk level chip — the swatch in the `risk_level` column header's legend
// (RiskLegendTooltip) — and RiskLevelCell, the column's cell renderer, which
// reserves the width of every level (ChipSlot) so the column can be measured.
//
// The vocabulary (which levels exist, their copy key, their colour)
// lives in riskLevels.js — see that file for why it is one list and how it is
// pinned to the backend.

import { useTranslation } from 'react-i18next';
import StatusChip from './StatusChip';
import ChipSlot from '../grid/ChipSlot';
import { RISK_CHIP_COLOR, RISK_LEVELS, riskLabelKey } from './riskLevels';

export default function RiskChip(params) {
  const { t } = useTranslation();
  const level = params.value;
  if (!level) return null;
  const color = RISK_CHIP_COLOR[level];
  // The vocabulary is pinned to the backend's (riskLevels.js), so a level
  // with no colour is a broken contract, not a level to print raw.
  if (!color) throw new Error(`RiskChip: unknown risk level "${level}"`);
  return <StatusChip label={t(`reports.stockout.${riskLabelKey(level)}`)} color={color} />;
}

export function RiskLevelCell({ value }) {
  if (!value) return null;
  const alternatives = RISK_LEVELS
    .filter((level) => level !== value)
    .map((level) => <RiskChip key={level} value={level} />);
  return <ChipSlot shown={<RiskChip value={value} />} alternatives={alternatives} />;
}
